export const DimensionNames = Object.freeze({
    ProductID: "ProductID",
    CountryID: "CountryID",
    YearID: "YearID",
    MetricID: "MetricID",
    ConversionID: "ConversionID"
})